import { Endpoints } from "../../../constants/endpoints";
import client from "../../client";
import { TPostMakeOffer, TPostMakeOfferBody } from "./types";

export const postQuoteJob = async (payload: TPostMakeOfferBody) => {
  const { data } = await client.post<TPostMakeOfferBody, TPostMakeOffer>(
    Endpoints.postQuoteJob(payload.jobId),
    {
      ...payload,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return data;
};
